(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-calculator')) {
    class ShippingCalculator extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.form = this.querySelector('[data-shipping-form]');
        this.zipInput = this.querySelector('[data-shipping-zip]');
        this.submitButton = this.querySelector('[data-shipping-submit]');
        this.errorElement = this.querySelector('[data-shipping-error]');
        this.resultsElement = this.querySelector('[data-shipping-results]');
        this.productForm = document.getElementById(this.dataset.productFormId);
        this.cartRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

        if (!this.form || !this.zipInput || !this.submitButton) return;

        this.zipInput.addEventListener('input', this.handleZipInput.bind(this));
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        this.watchVariantChange();
      }

      // KID-106: o prazo de preparo muda por variante (uma pode estar em estoque
      // e outra sob encomenda). O tema re-renderiza a seção na troca de variante,
      // então lemos o valor novo do HTML e mantemos o resultado já exibido válido.
      watchVariantChange() {
        if (!window.MinimogEvents || !window.MinimogTheme || !MinimogTheme.pubSubEvents) return;

        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (event) => {
          const fresh = event && event.data && event.data.html && event.data.html.querySelector('shipping-calculator');
          if (!fresh) return;

          this.dataset.handlingDays = fresh.dataset.handlingDays || '0';
          this.dataset.handlingKind = fresh.dataset.handlingKind || 'pronta';
          this.hideResults();
        });
      }

      handleZipInput(event) {
        const digits = event.target.value.replace(/\D/g, '').slice(0, 8);
        let formatted = digits;

        if (digits.length > 5) {
          formatted = `${digits.slice(0, 2)}.${digits.slice(2, 5)}-${digits.slice(5)}`;
        } else if (digits.length > 2) {
          formatted = `${digits.slice(0, 2)}.${digits.slice(2)}`;
        }

        event.target.value = formatted;
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (this.busy) return;

        const zip = this.zipInput.value.replace(/\D/g, '');
        if (zip.length !== 8) {
          this.showError(this.dataset.invalidZipMessage);
          return;
        }

        const variantInput = this.productForm && this.productForm.querySelector('[name="id"]');
        const variantId = variantInput ? Number(variantInput.value) : 0;
        if (!variantId) {
          this.showError(this.dataset.errorMessage);
          return;
        }

        this.setBusy(true);
        this.hideError();
        this.showLoading();

        try {
          const address = await this.fetchJson(`https://viacep.com.br/ws/${zip}/json/`);
          if (address.erro || !address.uf) throw new Error('invalid_zip');

          await this.calculateRates({
            variantId,
            quantity: this.getQuantity(),
            zip,
            province: this.getProvinceName(address.uf),
          });
        } catch (error) {
          this.hideResults();
          this.showError(this.dataset.errorMessage);
        } finally {
          this.setBusy(false);
        }
      }

      getQuantity() {
        const quantityInput = this.productForm && this.productForm.querySelector('.m-quantity__input');
        const quantity = quantityInput ? Number(quantityInput.value) : 1;
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      }

      getProvinceName(code) {
        const provinces = {
          AC: 'Acre',
          AL: 'Alagoas',
          AP: 'Amapa',
          AM: 'Amazonas',
          BA: 'Bahia',
          CE: 'Ceara',
          DF: 'Distrito Federal',
          ES: 'Espirito Santo',
          GO: 'Goias',
          MA: 'Maranhao',
          MT: 'Mato Grosso',
          MS: 'Mato Grosso do Sul',
          MG: 'Minas Gerais',
          PA: 'Para',
          PB: 'Paraiba',
          PR: 'Parana',
          PE: 'Pernambuco',
          PI: 'Piaui',
          RJ: 'Rio de Janeiro',
          RN: 'Rio Grande do Norte',
          RS: 'Rio Grande do Sul',
          RO: 'Rondonia',
          RR: 'Roraima',
          SC: 'Santa Catarina',
          SP: 'Sao Paulo',
          SE: 'Sergipe',
          TO: 'Tocantins',
        };

        return provinces[code] || code;
      }

      async calculateRates({ variantId, quantity, zip, province }) {
        const originalCart = await this.fetchJson(`${this.cartRoot}cart.js`);
        let ratesData;

        try {
          await this.fetchJson(`${this.cartRoot}cart/clear.js`, { method: 'POST' });
          await this.fetchJson(`${this.cartRoot}cart/add.js`, {
            method: 'POST',
            body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
          });

          const params = new URLSearchParams({
            'shipping_address[country]': 'Brazil',
            'shipping_address[province]': province,
            'shipping_address[zip]': zip,
          });

          ratesData = await this.fetchJson(`${this.cartRoot}cart/shipping_rates.json?${params.toString()}`);
        } finally {
          await this.restoreCart(originalCart);
        }

        if (!ratesData || !Array.isArray(ratesData.shipping_rates) || ratesData.shipping_rates.length === 0) {
          throw new Error('shipping_rates_unavailable');
        }

        this.renderRates(ratesData.shipping_rates);
      }

      async restoreCart(cart) {
        await this.fetchJson(`${this.cartRoot}cart/clear.js`, { method: 'POST' });

        if (cart.items && cart.items.length > 0) {
          const items = cart.items.map((item) => {
            const restoredItem = {
              id: item.variant_id,
              quantity: item.quantity,
              properties: item.properties,
            };

            if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
              restoredItem.selling_plan = item.selling_plan_allocation.selling_plan.id;
            }

            return restoredItem;
          });

          await this.fetchJson(`${this.cartRoot}cart/add.js`, {
            method: 'POST',
            body: JSON.stringify({ items }),
          });
        }

        if (cart.note || cart.attributes) {
          await this.fetchJson(`${this.cartRoot}cart/update.js`, {
            method: 'POST',
            body: JSON.stringify({ note: cart.note || '', attributes: cart.attributes || {} }),
          });
        }
      }

      async fetchJson(url, options = {}) {
        const headers = { Accept: 'application/json' };
        if (options.body) headers['Content-Type'] = 'application/json';

        const response = await fetch(url, {
          credentials: 'same-origin',
          headers,
          ...options,
        });

        if (!response.ok) throw new Error(`request_failed_${response.status}`);
        return response.json();
      }

      renderRates(rates) {
        this.resultsElement.replaceChildren();

        rates.forEach((rate) => {
          const item = document.createElement('div');
          const info = document.createElement('div');
          const name = document.createElement('p');
          const price = document.createElement('p');

          item.className = 'shipping-calculator__rate';
          info.className = 'shipping-calculator__rate-info';
          name.className = 'shipping-calculator__rate-name';
          price.className = 'shipping-calculator__rate-price';
          name.textContent = rate.name;
          price.textContent = Number(rate.price) === 0 ? this.dataset.freeShippingText : this.formatPrice(rate.price);

          info.appendChild(name);

          if (rate.delivery_date) {
            const delivery = document.createElement('span');
            const handlingDays = parseInt(this.dataset.handlingDays, 10) || 0;
            const isMadeToOrder = this.dataset.handlingKind === 'sob';

            delivery.className = 'shipping-calculator__rate-delivery';

            if (handlingDays > 0) {
              const arrival = this.addBusinessDays(rate.delivery_date, handlingDays);
              const suffix = isMadeToOrder ? ' (já inclui o prazo de produção)' : ' (já inclui o preparo do pedido)';
              delivery.textContent = `Entrega estimada: ${this.formatDate(arrival)}${suffix}`;
            } else {
              delivery.textContent = `Estimativa de entrega: ${this.formatDate(rate.delivery_date)}`;
            }

            info.appendChild(delivery);
          }

          item.append(info, price);
          this.resultsElement.appendChild(item);
        });

        this.resultsElement.hidden = false;
      }

      formatPrice(price) {
        const cents = Math.round(Number(price) * 100);

        if (typeof window.formatMoney === 'function') {
          return window.formatMoney(cents, this.dataset.moneyFormat);
        }

        const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'BRL';
        return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
          style: 'currency',
          currency,
        }).format(cents / 100);
      }

      formatDate(date) {
        const parsedDate = date instanceof Date ? date : new Date(`${date}T12:00:00`);
        return new Intl.DateTimeFormat(document.documentElement.lang || 'pt-BR').format(parsedDate);
      }

      // KID-106: soma dias ÚTEIS (pula sábado e domingo) à data da transportadora.
      addBusinessDays(isoDate, days) {
        const date = new Date(`${isoDate}T12:00:00`);
        let added = 0;

        while (added < days) {
          date.setDate(date.getDate() + 1);
          const weekday = date.getDay();
          if (weekday !== 0 && weekday !== 6) added += 1;
        }

        return date;
      }

      showLoading() {
        this.resultsElement.innerHTML =
          '<div class="shipping-calculator__loading"><svg class="shipping-calculator__spinner" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-opacity="0.2" stroke-width="3" fill="none"></circle><path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round"></path></svg></div>';
        this.resultsElement.hidden = false;
      }

      hideResults() {
        this.resultsElement.hidden = true;
        this.resultsElement.replaceChildren();
      }

      showError(message) {
        this.errorElement.textContent = message;
        this.errorElement.hidden = false;
      }

      hideError() {
        this.errorElement.hidden = true;
        this.errorElement.textContent = '';
      }

      setBusy(busy) {
        this.busy = busy;
        this.submitButton.disabled = busy;
        this.submitButton.setAttribute('aria-busy', String(busy));
      }
    }

    customElements.define('shipping-calculator', ShippingCalculator);
  }
  } catch(e) { console.error(e); }
})();

})();
